import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getDynamicSamplingContextFromSpan } from '../tracing/dynamicSamplingContext.js';
import { merge } from './merge.js';
import { spanToTraceContext, getRootSpan, spanToJSON } from './spanUtils.js';

/**
 * Applies data from the scope to the event and runs all event processors on it.
 */
function applyScopeDataToEvent(event, data) {
  var fingerprint = data.fingerprint,
    span = data.span,
    breadcrumbs = data.breadcrumbs,
    sdkProcessingMetadata = data.sdkProcessingMetadata;

  // Apply general data
  applyDataToEvent(event, data);

  // We want to set the trace context for normal events only if there isn't already
  // a trace context on the event. There is a product feature in place where we link
  // errors with transaction and it relies on that.
  if (span) {
    applySpanToEvent(event, span);
  }
  applyFingerprintToEvent(event, fingerprint);
  applyBreadcrumbsToEvent(event, breadcrumbs);
  applySdkMetadataToEvent(event, sdkProcessingMetadata);
}

/** Merge data of two scopes together. */
function mergeScopeData(data, mergeData) {
  var extra = mergeData.extra,
    tags = mergeData.tags,
    user = mergeData.user,
    contexts = mergeData.contexts,
    level = mergeData.level,
    sdkProcessingMetadata = mergeData.sdkProcessingMetadata,
    breadcrumbs = mergeData.breadcrumbs,
    fingerprint = mergeData.fingerprint,
    eventProcessors = mergeData.eventProcessors,
    attachments = mergeData.attachments,
    propagationContext = mergeData.propagationContext,
    transactionName = mergeData.transactionName,
    span = mergeData.span;
  mergeAndOverwriteScopeData(data, 'extra', extra);
  mergeAndOverwriteScopeData(data, 'tags', tags);
  mergeAndOverwriteScopeData(data, 'user', user);
  mergeAndOverwriteScopeData(data, 'contexts', contexts);
  data.sdkProcessingMetadata = merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
  if (level) {
    data.level = level;
  }
  if (transactionName) {
    data.transactionName = transactionName;
  }
  if (span) {
    data.span = span;
  }
  if (breadcrumbs.length) {
    data.breadcrumbs = [].concat(_toConsumableArray(data.breadcrumbs), _toConsumableArray(breadcrumbs));
  }
  if (fingerprint.length) {
    data.fingerprint = [].concat(_toConsumableArray(data.fingerprint), _toConsumableArray(fingerprint));
  }
  if (eventProcessors.length) {
    data.eventProcessors = [].concat(_toConsumableArray(data.eventProcessors), _toConsumableArray(eventProcessors));
  }
  if (attachments.length) {
    data.attachments = [].concat(_toConsumableArray(data.attachments), _toConsumableArray(attachments));
  }
  data.propagationContext = _objectSpread(_objectSpread({}, data.propagationContext), propagationContext);
}

/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */
function mergeAndOverwriteScopeData(data, prop, mergeVal) {
  data[prop] = merge(data[prop], mergeVal, 1);
}
function applyDataToEvent(event, data) {
  var extra = data.extra,
    tags = data.tags,
    user = data.user,
    contexts = data.contexts,
    level = data.level,
    transactionName = data.transactionName;
  if (Object.keys(extra).length) {
    event.extra = _objectSpread(_objectSpread({}, extra), event.extra);
  }
  if (Object.keys(tags).length) {
    event.tags = _objectSpread(_objectSpread({}, tags), event.tags);
  }
  if (Object.keys(user).length) {
    event.user = _objectSpread(_objectSpread({}, user), event.user);
  }
  if (Object.keys(contexts).length) {
    event.contexts = _objectSpread(_objectSpread({}, contexts), event.contexts);
  }
  if (level) {
    event.level = level;
  }

  // transaction events get their `transaction` from the root span name
  if (transactionName && event.type !== 'transaction') {
    event.transaction = transactionName;
  }
}
function applyBreadcrumbsToEvent(event, breadcrumbs) {
  var mergedBreadcrumbs = [].concat(_toConsumableArray(event.breadcrumbs || []), _toConsumableArray(breadcrumbs));
  event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
  event.sdkProcessingMetadata = _objectSpread(_objectSpread({}, event.sdkProcessingMetadata), sdkProcessingMetadata);
}
function applySpanToEvent(event, span) {
  event.contexts = _objectSpread({
    trace: spanToTraceContext(span)
  }, event.contexts);
  event.sdkProcessingMetadata = _objectSpread({
    dynamicSamplingContext: getDynamicSamplingContextFromSpan(span)
  }, event.sdkProcessingMetadata);
  var rootSpan = getRootSpan(span);
  var transactionName = spanToJSON(rootSpan).description;
  if (transactionName && !event.transaction && event.type === 'transaction') {
    event.transaction = transactionName;
  }
}

/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */
function applyFingerprintToEvent(event, fingerprint) {
  // Make sure it's an array first and we actually have something in place
  event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [event.fingerprint] : [];

  // If we have something on the scope, then merge it with event
  if (fingerprint) {
    event.fingerprint = event.fingerprint.concat(fingerprint);
  }

  // If we have no data at all, remove empty array default
  if (!event.fingerprint.length) {
    delete event.fingerprint;
  }
}
export { applyScopeDataToEvent, mergeAndOverwriteScopeData, mergeScopeData };